import { Component, Inject } from '@angular/core';
import { FileMergeService } from './file-merge.service';
import { WEB_VIEWER_LIBRARY_PATH } from '@onviobr/document-components';
import { WebViewerInstance } from '@pdftron/webviewer';

@Component({
	selector: 'app-file-merge',
	templateUrl: './file-merge.component.html',
	styleUrls: ['./file-merge.component.scss']
})
export class FileMergeComponent {
	public wvInstance!: WebViewerInstance;
	webViewerLibPath: string;

	constructor(@Inject(WEB_VIEWER_LIBRARY_PATH) webViewerLibPath: string,
		private _fileMergeService: FileMergeService) {
		this.webViewerLibPath = webViewerLibPath;
	}

	public async onWebViewerLoad(value: any) {
		this.wvInstance = value.detail;
		this._fileMergeService.webViewerInstance = this.wvInstance;
	}
}
